import { render, staticRenderFns } from "./PeopleACtions-comp.vue?vue&type=template&id=3f39898b&scoped=true&"
import script from "./PeopleACtions-comp.vue?vue&type=script&lang=js&"
export * from "./PeopleACtions-comp.vue?vue&type=script&lang=js&"
import style0 from "./PeopleACtions-comp.vue?vue&type=style&index=0&id=3f39898b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f39898b",
  null
  
)

export default component.exports